module.exports = __webpack_public_path__ + "img/Small-2-Bevel-Attachment-26.1e0054de.png";